import { NavigationItem } from '../api.types';

/**
 * Just a map of parent-keys to the items in that group\
 * Root group key is "ROOT"
 *
 * See description on the `constructGroups` function in the menu component
 */
export class GroupedItems extends Map<string, NavigationItem[]> {}
